<strong>Open opgeslagen template</strong>
<mat-selection-list>
    <mat-list-option *ngFor="let template of data.savedTemplates;" (click)="openTemplate(template)">{{template.name}} {{template.type}} {{template.date | date:'dd-MM-yyyy HH:mm:ss'}}</mat-list-option>
</mat-selection-list>

<button mat-flat-button color="primary" (click)="openNew()">Open orgineel</button>